import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { RootModule } from "./root/root.module";
import { environment } from "../../environments/environment";
import { applyCachedOneWebShell } from "../../common/helpers/oneWebShell.helper";

if (environment.production) {
    enableProdMode();
}

applyCachedOneWebShell();

platformBrowserDynamic().bootstrapModule(RootModule);
